<ng-container *transloco="let t; prefix: scope">
  <h2 mat-dialog-title>{{ t('title', { name: shortName }) }}</h2>

  <img alt="" [src]="'dashboard/onboarding/success-modal-reviews.png' | staticImageUrl" />

  <div mat-dialog-content>
    <div class="p-6 text-left" [innerHtml]="t('body') | stripNewLine"></div>
  </div>
  <div mat-dialog-actions align="end">
    <button type="button" mat-stroked-button color="primary" mat-dialog-close>{{ t('close') }}</button>
  </div>
</ng-container>
